/**
 * 配信mountの公開base pathを、pathnameの純粋なパースだけで求める。
 *
 * 本番の `/b/` と `/mix` はnginxの静的配信で、frontend Workerを経由しない
 * (docs/current-system-architecture.md「frontend Workerの`/b/*` routeは使用しない」)。
 * そのためmount判定をサーバー描画やconfig層に依存させられない。config層の
 * importはWorker専用の本番env検証をentry chunkへ持ち込み、全ページを
 * 無地で停止させる(2026-08-23の本番障害)。
 */

// worker.tsのresolveBoardRequestPath / resolveMixRequestPathと同じmount形
const BOARD_MOUNT_PATTERN = /^\/b\/([^/]+)(?:\/|$)/;
const MIX_MOUNT_PATTERN = /^\/mix(?:\/|$)/;

/**
 * `/b/{slug}`、`/mix`、またはroot mountの空文字を返す。
 * 末尾スラッシュは付けない(呼び出し側が `${base}/manifest.json` の形で使う)。
 */
export function resolveMountBasePath(pathname: string): string {
  const boardSlug = BOARD_MOUNT_PATTERN.exec(pathname)?.[1];
  if (boardSlug !== undefined) return `/b/${boardSlug}`;
  if (MIX_MOUNT_PATTERN.test(pathname)) return "/mix";
  return "";
}

/** mount配下の公開パスを組み立てる。root mountでは先頭スラッシュだけが残る。 */
export function mountPublicPath(
  pathname: string,
  resourcePath: string,
): string {
  return `${resolveMountBasePath(pathname)}${resourcePath}`;
}
